import auth from "../../middlewares/auth";

export const cloudDiskRoutes = [
    {
        path: '/cloud-disks',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/cloud_disks/CloudDiskIndex.vue'),
        name: 'cloud_disks',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/create-cloud-disk',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/cloud_disks/CreateCloudDiskForm.vue'),
        name: 'create_cloud_disk',
        meta: {
            middleware: [
                auth
            ]
        }
    },
]